export const getters = {
  coupon: state => {
    return {
      couponId: state.couponId,
      couponText: state.couponText,
      couponDiscount: state.couponDiscount,
      couponType: state.couponType
    }
  },
  invoice: state => {
    return {
      invoiceId: state.invoiceId,
      invoiceText: state.invoiceText,
      invoiceIsCompany: state.invoiceIsCompany,
      isAddInvoice: state.isAddInvoice,
      invoiceCode: state.invoiceCode
    }
  },
  gaStation: state => {
    return {
      gaStationId: state.gaStationId,
      gaStation: state.gaStation
    }
  },
  loginShow: state => state.loginShow,
  userMasge: state => state.userMasge,
  getMsg: state => {
    return {
      amountOfRefueling: state.amountOfRefueling,
      oilGun: state.oilGun,
      selectOilOrderId: state.selectOilOrderId
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/pay/getters.js